/**
 * The screen a view kind we have not built renders (`specs/M4-V1-views.md` §5, acceptance R2).
 *
 * The alternative — a table pretending to be a gantt — is worse than an honest placeholder, and
 * an error is worse still: **64 views** in this account are of kinds M4 has not reached, and a
 * user who opens one must see what it is and when it lands, not a stack trace `[vui]`.
 */
import { PageEmptyState } from '@elizmonday/ui';
import { Link } from 'react-router';
import './views.css';

export function ComingSoonView({
  boardId,
  title,
  plannedIn,
  mondayType,
}: {
  boardId: string;
  title: string;
  plannedIn: string | null;
  mondayType?: string | null;
}) {
  const known = plannedIn !== null;
  return (
    <div className="ez-coming-soon" data-testid="coming-soon-view" data-kind={title}>
      <PageEmptyState
        title={known ? `${title} views are coming` : `This view is not supported yet`}
        hint={
          known
            ? `The ${title} view lands with ${plannedIn}. Its configuration is already stored, so nothing is lost in the meantime.`
            : `monday calls this view "${mondayType ?? 'unknown'}". Its configuration is stored verbatim and will render once the kind is built.`
        }
        data-testid="coming-soon-body"
      />
      <Link className="ez-coming-soon__link" to={`/boards/${boardId}`} data-testid="coming-soon-link">
        Open the board's table view
      </Link>
    </div>
  );
}
